module.exports = __webpack_public_path__ + "static/media/ic_search_blue.9c360a9e.svg";